import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '../../../baseQuery/baseReportsQuery';
import { UsageMetricsResponse, TenantUser } from './types';
import { createUsageTrackerBody } from './utils';
import { API_USAGE_TRACKER } from './constants';

export const tenantUsageTrackerApi = createApi({
    reducerPath: 'tenantUsageTrackerApi',
    baseQuery,
    refetchOnMountOrArgChange: true,
    endpoints: (builder) => ({
        getMetricsByUserId: builder.query<UsageMetricsResponse, { userId: number; year: number; months: string[] }>({
            query: ({ userId, year, months }) => ({
                url: `${API_USAGE_TRACKER}/tenant/users/${userId}`,
                method: 'POST',
                body: createUsageTrackerBody(year, months),
            }),
        }),
        getMetricsByUsers: builder.query<TenantUser[], void>({
            query: () => ({
                url: `${API_USAGE_TRACKER}/tenant/users`,
                method: 'GET',
            }),
        }),
        getMetricsByAllUsers: builder.query<UsageMetricsResponse, { year: number; months: string[] }>({
            query: ({ year, months }) => ({
                url: `${API_USAGE_TRACKER}/tenant`,
                method: 'POST',
                body: createUsageTrackerBody(year, months),
            }),
        }),
    }),
});

export const { useGetMetricsByUserIdQuery, useGetMetricsByUsersQuery, useGetMetricsByAllUsersQuery } =
    tenantUsageTrackerApi;
